<template>
  <div class="checkIn weight">
    <mu-row class="content" style="align-items: center" gutter>
      <mu-col width="100" desktop="50" tablet="50" class="paddingRight">
        <div class="bigTxt first">By this point in the program, many people have reported weight loss.</div>

        <div class="bigTxt">Fill us in on how you're getting along!</div>
      </mu-col>
      <mu-col width="100" desktop="50" tablet="50">
        <form novalidate @submit.prevent="submitForm">
          <mu-card style="width: 280px; margin: 0 auto;">
            <mu-card-text class="pad">
              <div class="lgTxt"> Right now, I weigh...</div>
              <mu-row gutter align="center">
                <mu-col width="100" tablet="100" desktop="100"
                        v-if="$store.state.user.settings.weight.measure === 'kg'">

                  <div class="shadow">
                    <input
                      class="input"
                      v-validate
                      v-bind:class="{'hasError': errors.has('kg')}"
                      type="number"
                      :data-vv-rules="'required|min_value:0|max_value:635'"
                      data-vv-name="kg"
                      data-vv-value-path="inputValue"
                      :errorText="errors.first('kg')"
                      label="KG"
                      hintText="Weight in kg"
                      v-model.number="model.kg"
                    />
                  </div>
                  <div class="label">Kilograms (kg)</div>
                </mu-col>
                <mu-col width="100" tablet="100" desktop="100"
                        v-if="$store.state.user.settings.weight.measure === 'lbs'">

                  <div class="shadow">
                    <input
                      class="input"
                      v-validate
                      v-bind:class="{'hasError': errors.has('lbs')}"
                      :data-vv-rules="'required|min_value:0|max_value:750'"
                      data-vv-name="lbs"
                      :errorText="errors.first('lbs')"
                      type="number"
                      label="POUNDS"
                      v-model.number="model.lbs"
                    />
                  </div>
                  <div class="label">Pounds (lbs)</div>
                </mu-col>
                <mu-col width="50" tablet="50" desktop="50"
                        v-if="$store.state.user.settings.weight.measure === 'st-lbs'">
                  <div class="shadow">
                    <input
                      class="input"
                      v-validate
                      v-bind:class="{'hasError': errors.has('stones')}"
                      :data-vv-rules="'required|min_value:0|max_value:100'"
                      data-vv-name="stones"
                      type="number"
                      v-model.number="model.stones"
                    />
                  </div>
                  <div class="label">
                    Stones (st)
                  </div>
                </mu-col>
                <mu-col align="center" width="50" tablet="50" desktop="50"
                        v-if="$store.state.user.settings.weight.measure === 'st-lbs'">
                  <div class="shadow">
                    <input
                      class="input"
                      v-validate
                      v-bind:class="{'hasError': errors.has('pounds')}"
                      :data-vv-rules="'required|min_value:0|max_value:13'"
                      data-vv-name="pounds"
                      :errorText="errors.first('pounds')"
                      type="number"
                      v-model.number="model.pounds"
                    />
                  </div>
                  <div class="label">
                    Pounds (lbs)
                  </div>

                </mu-col>
              </mu-row>
              <button type="submit" style="display: none;"></button>
              <mu-raised-button
                :disabled="isProcessing"
                type="button"
                @click.native="submitForm"
                style="margin-top: 16px;"
                :label="isProcessing ? $t('message.savingText') : $t('message.nextText')"
                secondary fullWidth></mu-raised-button>
            </mu-card-text>
          </mu-card>
        </form>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>
  import CheckInApi from '../../api/CheckIn';

  export default {
    data() {
      return {
        isProcessing: false,
        model: {},
        status: {}
      }
    },
    mounted() {
      let self = this;
      CheckInApi.getCheckInStatus()
        .then(function (response) {
          self.status = response.data;
        });
    },
    methods: {
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              self.isProcessing = true;
              CheckInApi.addWeight(self.model)
                .then(function (response) {
                  self.isProcessing = false;
                  if (self.status.isDiabetic === true) {
                    self.$router.push({
                      name: 'Hba1cCheckin'
                    })
                  }
                  else {
                    self.$router.push({
                      name: 'GoalsCheckin'
                    })
                  }
                  self.$toastr.success("Added weight reading");
                });
            }
          })
      }
    }
  }
</script>
<style lang="less">
  .checkIn.weight {
    .paddingRight {
      padding-right: 24px;
      @media(max-width: 600px) {
        padding-right: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Weight.vue?7fa691f7